import { useEffect, useState } from "react";

/** Returns true if the page is embedded inside a Teams iframe. */
export function isInsideTeams(): boolean {
  try {
    return (
      typeof window !== "undefined" &&
      window.parent !== window &&
      (window.location.ancestorOrigins != null
        ? Array.from(window.location.ancestorOrigins).some((o) =>
            o.includes("teams.microsoft.com") ||
            o.includes("teams.cloud.microsoft") ||
            o.includes("skype.com"),
          )
        : // ancestorOrigins not available in Firefox — fall back to URL param Teams injects
          new URLSearchParams(window.location.search).has("theme"))
    );
  } catch {
    return false;
  }
}

export function useOnline(): boolean {
  const [online, setOnline] = useState<boolean>(() => {
    if (typeof navigator === "undefined") return true;
    // navigator.onLine is unreliable inside a Teams iframe — always treat as online.
    if (isInsideTeams()) return true;
    return navigator.onLine;
  });

  useEffect(() => {
    if (isInsideTeams()) return;
    const onUp = () => setOnline(true);
    const onDown = () => setOnline(false);
    window.addEventListener("online", onUp);
    window.addEventListener("offline", onDown);
    return () => {
      window.removeEventListener("online", onUp);
      window.removeEventListener("offline", onDown);
    };
  }, []);

  return online;
}
